module.exports = __webpack_public_path__ + "static/media/logo.7fca3830.png";